import React, {ReactNode} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import {isMobile} from 'react-device-detect';
import Config from 'app/Config';
import {prepareSameWindowUrl, buildUrlAndOpenWindow} from 'app/utilities/StringHelpers/StringHelpers';
import './GuidesBlock.scss';
import Image from 'app/Components/Shared/Image/image';
import rightIcon from './images/right.svg';

export default class GuidesBlock extends EpiComponent<any> {
  public componentDidMount(): void {
    try {
      this.getContext()?.getStore()?.dispatch({
        type: 'guidesBlock/reportDWH',
        payload: {
          actionType: 'GuidsPage',
          status: 'Ongoing',
          messageText: 'Guids Page Displayed',
        },
      });
    } catch {}
  }

  public render(): ReactNode | null {
    const data = this.props.data ?? {};
    const title = data.title?.value ?? '';
    const guideLinks = data.guideLinks?.expandedValue ?? [];

    const resolveImageUrl = (url?: string | null) => {
      if (!url) return null;
      if (/^https?:\/\//i.test(url)) return url;
      return `${Config?.epiBaseUrl ?? ''}${url}`;
    };

    const handleGuideLinkClick = (event: React.MouseEvent, item: any) => {
      event.preventDefault();
      event.stopPropagation();

      this.getContext()?.getStore()?.dispatch({
        type: 'guidesBlock/reportDWH',
        payload: {
          actionType: 'GuidsPage',
          status: 'Ongoing',
          messageText: 'Guids Page Displayed',
          param4: item?.faultName?.value ?? '',
        },
      });

      const link = item?.guidePage?.value;

      if (!link) {
        return null;
      }

      const isPdfLink = /\.pdf($|\?)/i.test(link);

      if (isPdfLink) {
        buildUrlAndOpenWindow(link);
        return;
      }

      prepareSameWindowUrl(link, this.getContext());
    };

    const backgroundImageDesktop = resolveImageUrl(data.backgroundImageDesktop?.value?.url ?? null);
    const backgroundImageMobile = resolveImageUrl(data.backgroundImageMobile?.value?.url ?? null);
    const backgroundImage = isMobile ? backgroundImageMobile ?? backgroundImageDesktop : backgroundImageDesktop ?? backgroundImageMobile;

    return (
      <section className={`guides-block ${!backgroundImage ? 'guides-block-fallback' : ''}`} style={backgroundImage ? {backgroundImage: `url(${backgroundImage})`} : undefined}>
        <button className='guides-block-back-button' onClick={() => window.history.back()}>
        <Image src={rightIcon} alt='חזרה' />
          <span>חזרה</span>
        </button>
        <div className='guides-block-header'>
          <div className='guides-block-overlay' />
          <div className='guides-block-content'>
            <div className='guides-block-title' dangerouslySetInnerHTML={{__html: title}}></div>
          </div>
        </div>

        {guideLinks.length > 0 && (
          <div className='guides-block-links-wrapper'>
            <div className='guides-block-links'>
              {guideLinks.map((item: any, index: number) => (
                <button key={index} type='button' className='guides-block-link-item' onClick={(event) => handleGuideLinkClick(event, item)}>
                  <span className='guides-block-link-content'>
                    <span className='guides-block-link-title'>{item?.faultName?.value}</span>
                    {item?.icon?.value?.url && (
                      <img
                        className='guides-block-link-icon'
                        src={`${Config?.epiBaseUrl ?? ''}${item?.icon?.value?.url}`}
                        alt=''
                        aria-hidden='true'
                      />
                    )}
                  </span>
                </button>
              ))}
            </div>
          </div>
        )}
      </section>
    );
  }
}
